export const aiMapping = {
    chat: {
        default: 'gpt',
        options: [
            {
                name: 'gpt',
                api: 'openai/chat',
                label: 'OpenAI - GPT'
            },
            /*
            {
                name: 'gemini',
                api: 'google/chat',
                label: 'Google - Gemini'
            },
            {
                name: 'claude',
                api: 'anthropic/chat',
                label: 'Anthropic - Claude'
            }

             */
        ]
    },
    createImage: {
        default: 'vertex',
        options: [
            {
                name: 'dall_e',
                api: 'openai/image',
                label: 'OpenAI - DALL·E'
            },
            {
                name: 'vertex',
                api: 'google/image',
                label: 'Google - Vertex'
            }
        ]
    },
    editImage: {
        default: 'vertex',
        options: [
            {
                name: 'vertex',
                api: 'google/image',
                label: 'Google - Vertex'
            }
        ]
    },
    createVideo: {
        default: 'veo',
        options: [
            {
                name: 'DALL-E 3',
                api: 'openai/createVideo',
                label: 'OpenAI - DALL-E 3'
            },
            {
                name: 'veo',
                api: 'google/createVideo',
                label: 'Google - Veo'
            }
        ]
    },
    editVideo: {
        default: 'veo',
        options: [
            {
                name: 'sora',
                api: 'openai/createVideo',
                label: 'OpenAI - Sora'
            },
            {
                name: 'veo',
                api: 'google/createVideo',
                label: 'Google - Veo 2'
            }
        ]
    }
};

